var N = Object.defineProperty, S = Object.defineProperties;
var w = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty, b = Object.prototype.propertyIsEnumerable;
var h = (e, t, r) => t in e ? N(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, p = (e, t) => {
  for (var r in t || (t = {}))
    y.call(t, r) && h(e, r, t[r]);
  if (i)
    for (var r of i(t))
      b.call(t, r) && h(e, r, t[r]);
  return e;
}, m = (e, t) => S(e, w(t));
var g = (e, t) => {
  var r = {};
  for (var o in e)
    y.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && i)
    for (var o of i(e))
      t.indexOf(o) < 0 && b.call(e, o) && (r[o] = e[o]);
  return r;
};
import { jsxs as x, jsx as a } from "react/jsx-runtime";
import n from "../../../node_modules/prop-types/index.es.js";
import B, { useId as E } from "react";
import * as H from "./style.es.js";
import { Input as L, InputBody as q, InputElement as z, InputCheckmark as A, InputLabel as D } from "./style.es.js";
import { Helper as G } from "../../DataDisplay/Helper/Helper.es.js";
import { POSITION as O } from "../../../constants/position.es.js";
const d = B.forwardRef((J, C) => {
  var I = J, {
    id: e,
    className: t,
    name: r,
    label: o,
    onChange: T,
    helperText: R,
    disabled: f = !1,
    error: c = !1,
    success: u = !1,
    labelPosition: j = O.right,
    alignItems: P = "center",
    typographyProps: k = {}
  } = I, v = g(I, [
    "id",
    "className",
    "name",
    "label",
    "onChange",
    "helperText",
    "disabled",
    "error",
    "success",
    "labelPosition",
    "alignItems",
    "typographyProps"
  ]);
  const F = E(), l = e || F;
  return /* @__PURE__ */ x(L, { error: c, success: u, disabled: f, type: "radio", ref: C, className: t, children: [
    /* @__PURE__ */ x(q, { labelPosition: j, alignItems: P, children: [
      /* @__PURE__ */ a(z, m(p({ type: "radio", id: l, name: r, onChange: T, disabled: f }, v), { ref: (s) => (s && (s.indeterminate = !1), s) })),
      /* @__PURE__ */ a(A, { htmlFor: l }),
      o && /* @__PURE__ */ a(D, m(p({ as: "label", htmlFor: l, variant: "body2" }, k), { children: o }))
    ] }),
    /* @__PURE__ */ a(G, { text: R, error: c, success: u })
  ] });
});
d.S = H;
d.displayName = "Radio";
d.propTypes = {
  id: n.string,
  name: n.string,
  label: n.oneOfType([n.string, n.node]),
  onChange: n.func,
  helperText: n.string,
  disabled: n.bool,
  error: n.bool,
  success: n.bool,
  labelPosition: n.oneOf(Object.values(O)),
  alignItems: n.oneOf(["center", "flex-start", "flex-end"])
};
export {
  d as Radio
};
//# sourceMappingURL=Radio.es.js.map
